import request from "../utils/request";

export async function getDayReportEnable() {
    return request.get("DayReportSetting/GetDayReportEnable");
  }